import { useTranslation } from "react-i18next";
import { TextType } from "@/components/TextType";
import { SchedaAd } from "./SchedaAd";

/**
 * The apex hero: the production headline, typed with TextType's defaults (250ms before
 * it starts, 55ms a character), beside the real {@link SchedaAd}, unchanged, with its
 * 9.5s cross-fade.
 *
 * <p>The headline types itself, so the line it will end on is reserved up front by a
 * hidden copy of the full text (.hl .ghost). Without that the advert beside it would
 * re-centre on every wrap of the growing line.
 *
 * <p>`onTry` is threaded from the bundle root rather than resolved here: the apex and
 * the app both render this landing, and PublicLinks-style URL shapes should have one
 * owner. See catalog/CatalogApp.tsx.
 */
export function Hero({ onTry }: { onTry: () => void }) {
  const { t } = useTranslation();
  const title = t("hero.title");

  return (
    <section id="top" className="hero relative">
      <div className="landing-bg" aria-hidden="true" />
      <div className="wrap herogrid relative">
        <div>
          <h1 className="hl" aria-label={title}>
            <span className="ghost" aria-hidden="true">
              {title}
            </span>
            <span className="live" aria-hidden="true">
              <TextType as="span" text={title} showCursor cursorClassName="type-caret ink-accent" />
            </span>
          </h1>
        </div>

        {/* The product's advert in the slot the agent figure used to fill. Matte on
            purpose: it is a photograph, not a surface. See SchedaAd.tsx for the
            promo-* naming constraint and the matched-pair rule. */}
        <SchedaAd onTry={onTry} />
      </div>
    </section>
  );
}
